/* Native article enhancement; saved article content remains in the initial HTML. */
if (!customElements.get('pp-editorial')) {
  customElements.define('pp-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const body = this.querySelector('[data-article-body]');
      if (!body) return;
      // Legacy images sometimes keep their URL only in data attributes.
      body.querySelectorAll('img').forEach(img => {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.loading = 'lazy';
        img.decoding = 'async';
        if (!img.sizes || img.sizes === 'auto') img.sizes = '(max-width: 767px) calc(100vw - 40px), 740px';
      });
      const firstImage = body.querySelector('img[src]:not([src=""])');
      if (firstImage) firstImage.loading = 'eager';
      body.querySelectorAll('p').forEach(p => {
        if (!p.textContent.trim() && !p.querySelector('img,iframe,video,button,input')) p.hidden = true;
      });
      // Keep all original heading IDs, so old links into an article still work.
      const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
      if (headings.length >= 3) {
        const sidebar = this.querySelector('.pp-article-sidebar');
        const list = sidebar.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `pp-heading-${this.dataset.section}-${index + 1}`;
            while (document.getElementById(id)) id += '-x';
            heading.id = id;
          }
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${encodeURIComponent(heading.id)}`;
          a.textContent = heading.textContent.trim();
          li.append(a); list.append(li);
        });
        sidebar.hidden = false;
        const toc = sidebar.querySelector('details');
        toc.open = matchMedia('(min-width: 1024px)').matches;
        // Hide the old table only after its replacement has been built.
        body.querySelectorAll('.bggle_table-of-content').forEach(el => el.hidden = true);
      }
      body.querySelectorAll('.faq--container').forEach((old, index) => {
        const q = old.querySelector('.bggle--question-title');
        const answer = old.querySelector('.reponse');
        if (!q || !answer) return;
        const details = document.createElement('details');
        details.className = 'pp-article-faq';
        details.name = `pp-faq-${this.dataset.section}`;
        if (old.id) details.id = old.id;
        const summary = document.createElement('summary');
        summary.textContent = q.textContent.trim();
        const content = document.createElement('div');
        content.append(answer); details.append(summary, content); old.replaceWith(details);
      });
      body.querySelectorAll('[bggle-product-handle], .bggle_product-container').forEach(container => this.productCard(container));
    }
    async productCard(container) {
      const oldLink = container.querySelector('a[href]');
      let linkedHandle = '';
      try { linkedHandle = new URL(oldLink?.getAttribute('href') || '', location.origin).pathname.match(/\/products\/([^/]+)/)?.[1] || ''; } catch (_) {}
      const handle = container.getAttribute('bggle-product-handle') || linkedHandle;
      if (!handle || !/^[a-zA-Z0-9_-]+$/.test(handle)) return;
      const root = window.Shopify?.routes?.root || '/';
      const link = document.createElement('a');
      link.className = 'pp-article-product';
      link.href = `${root}products/${encodeURIComponent(handle)}`;
      const label = document.createElement('span');
      label.textContent = 'Se produktet';
      link.append(label);
      // These containers contain only Bloggle's generated product widget.
      // The surrounding editorial text and its links are left intact.
      container.replaceChildren(link);
      try {
        const response = await fetch(`${link.pathname}.js`, {signal: AbortSignal.timeout(8000)});
        if (!response.ok) return;
        const product = await response.json();
        if (!this.isConnected) return;
        const title = document.createElement('strong');
        title.textContent = product.title;
        link.prepend(title);
        if (product.featured_image) {
          const url = new URL(product.featured_image, location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
          url.searchParams.set('width', '500');
          const img = document.createElement('img');
          img.src = url.href; img.alt = product.title; img.loading = 'lazy';
          link.prepend(img);
        }
      } catch (_) {
        // The link remains usable when the product request fails.
      }
    }
  });
}
